/* eslint-disable @typescript-eslint/naming-convention */
import { AncillaryLoad } from 'src/api';

export const ancillaryConfig: AncillaryLoad = {
  config_type: AncillaryLoad.config_type.ANCILLARY_LOAD,
};
